export const useAttributes = (table: string) => {

    const {$i18n} = useNuxtApp()

    return {
        ta: (attribute: string) => $i18n.te(`${table}.attributes.${attribute}`) ? $i18n.t(`${table}.attributes.${attribute}`) as string : attribute
    }
}
